import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  HelpCircle,
  Menu,
  X,
  FileText,
  Home,
  Settings,
  Grid,
} from "lucide-react";

const Navbar = ({ openHowToPlay, openGenerateCards, currentPath }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-gradient-to-r from-indigo-600 to-purple-700 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <svg
                className="h-8 w-8 fill-current text-purple-300"
                viewBox="0 0 24 24"
              >
                <path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M5,5V19H19V5H5M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z" />
              </svg>
              <span className="ml-2 text-xl font-bold">Call My Bingo</span>
            </Link>
          </div>

          {/* Desktop Nav Items */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPath === "/" ? "bg-purple-800" : "hover:bg-purple-800"
              } transition duration-150 flex items-center space-x-1`}
            >
              <Home size={18} />
              <span>Home</span>
            </Link>
            <Link
              to="/bingo-patterns"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPath === "/bingo-patterns"
                  ? "bg-purple-800"
                  : "hover:bg-purple-800"
              } transition duration-150 flex items-center space-x-1`}
            >
              <Grid size={18} />
              <span>Winning Patterns</span>
            </Link>
            <Link
              to="/how-to-play-bingo"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPath === "/how-to-play-bingo"
                  ? "bg-purple-800"
                  : "hover:bg-purple-800"
              } transition duration-150 flex items-center space-x-1`}
            >
              <HelpCircle size={18} />
              <span>How to Play</span>
            </Link>
            <Link
              to="/bingo-cards-generator"
              className={`px-3 py-2 rounded-md text-sm font-medium ${
                currentPath === "/bingo-cards-generator"
                  ? "bg-purple-800"
                  : "hover:bg-purple-800"
              } transition duration-150 flex items-center space-x-1`}
            >
              <FileText size={18} />
              <span>Printable Cards</span>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-purple-200 hover:text-white hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`${isOpen ? "block" : "hidden"} md:hidden bg-indigo-700`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <Link
            to="/"
            className="w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-purple-800 transition duration-150 flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <Home size={18} />
            <span>Home</span>
          </Link>
          <Link
            to="/bingo-patterns"
            className="w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-purple-800 transition duration-150 flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <Grid size={18} />
            <span>Winning Patterns</span>
          </Link>
          <Link
            to="/how-to-play-bingo"
            className="w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-purple-800 transition duration-150 flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <HelpCircle size={18} />
            <span>How to Play</span>
          </Link>
          <Link
            to="/generate-bingo-cards"
            className="w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-purple-800 transition duration-150 flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <FileText size={18} />
            <span>Printable Cards</span>
          </Link>
          <button
            className="w-full text-left px-3 py-2 rounded-md bg-pink-500 text-base font-medium hover:bg-pink-600 transition duration-150 flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <Settings size={18} />
            <span>Game Setup</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
